import { css } from '@emotion/core';
import { constants } from '@newsela/angelou';

const { colors } = constants;

export const $crossWalksCounter = css`
  background-color: ${colors.ui.neutral[500]};
  color: #fff !important;
  border-radius: 2px;
  padding: 2px 4px;
  font-size: 12px;
  font-weight: 400;
  height: 24px;
`;

export const $crosswalksToggle = css`
  color: ${colors.ui.neutral[500]};
  border-radius: 2px;
  border: 1px solid ${colors.ui.neutral[500]};
  padding: 2px 4px;
  font-size: 12px;
  font-weight: 400;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const $showIcon = css`
  width: 16px;
  cursor: pointer;
  margin-right: 2px;
`;
